////////// internals
import { getApiKeyHeader } from "./apimanager.helper";

const _domain = "data";
function request(url) {
  return fetch(url, {
    headers: {
      ...getApiKeyHeader(),
    },
  }).then((resp) => resp.json());
}

function _getVersion(version) {
  let v = version;
  if (!v) {
    var rounding = 1000 * 60 * 1; // round by one minute
    v = Math.round(new Date().getTime() / rounding) * rounding;
  }
  return v;
}

export default class ContentManager {
  static getURL() {
    if (process.env.ENV === "uat") {
      if (
        window.location.pathname.includes("prodreader.html") ||
        window.location.pathname.includes("prod_index.html")
      ) {
        return "https://" + process.env.TARGET_DOMAIN_PROD + "/data";
      } else if (process.env.NODE_ENV === "production") {
        return "../..";
      } else {
        return _domain;
      }
    } else {
      if (process.env.NODE_ENV === "production") {
        return "../..";
      } else {
        return _domain;
      }
    }
  }

  static domain_url = ContentManager.getURL();

  static getContentPackagePublications(contentPackageId) {
    return request(
      `${this.domain_url}/${contentPackageId}/data/GetContentPackagePublications-${contentPackageId}-V3.json?t=` +
        new Date().getTime()
    );
  }

  static getNonExpiredShelfPublications(contentPackageId) {
    return request(
      `${this.domain_url}/${contentPackageId}/data/GetNonExpiredShelfPublications.json?t=` +
        new Date().getTime()
    );
  }

  static getPublicationTDM(contentPackageId, publicationId) {
    return request(
      `${this.domain_url}/${contentPackageId}/NextGenData/publicationTDM-${publicationId}.json`
    );
  }

  static getPublicationPages(contentPackageId, publicationId, version) {
    return request(
      `${
        this.domain_url
      }/${contentPackageId}/data/GetPublicationPages-${publicationId}.json?t=${_getVersion(
        version
      )}`
    );
  }

  static getPublicationPageContent(contentPackageId, publicationId, version) {
    return request(
      `${
        this.domain_url
      }/${contentPackageId}/data/GetPublicationPageContent-${publicationId}.json?t=${_getVersion(
        version
      )}`
    );
  }

  static getPublicationContentItems(contentPackageId, publicationId, version) {
    return request(
      `${
        this.domain_url
      }/${contentPackageId}/data/GetPublicationContentItems-${publicationId}.json?t=${_getVersion(
        version
      )}`
    );
  }

  static getPublicationPageContentItems(
    contentPackageId,
    publicationId,
    version
  ) {
    return request(
      `${
        this.domain_url
      }/${contentPackageId}/data/GetPublicationPageContentItems-${publicationId}.json?t=${_getVersion(
        version
      )}`
    );
  }

  static requestJson(url) {
    return fetch(url, {
      headers: {
        ...getApiKeyHeader(),
      },
    })
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        } else {
          throw resp.status;
        }
      })
      .catch((err) => {
        throw err;
      });
  }
}



// WEBPACK FOOTER //
// ./src/common/utilities/contentmanager.js